import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import MicIcon from '../../../images/vector/mic.svg';

const MicButton = ({ text, onClick, className, disabled }) => (
    <button aria-label={text} className={classNames('mic-button', className)} onClick={onClick} disabled={disabled}>
        <MicIcon />
        {text}
    </button>
);

MicButton.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

MicButton.defaultProps = {
    className: '',
    disabled: false,
};

export default MicButton;
